export function formatError(error: string) {
	try {
		return JSON.stringify(JSON.parse(error), null, 4);
	} catch (err) {
		return error;
	}
}
